// CPL Logo
export { default as ClearPathLendingLogo } from "./logo.webp";

// Home
export { default as BuyingHome } from "./home_icon1.webp";
export { default as RefinancingMortgage } from "./home_icon2.webp";
export { default as MortgageCalculators } from "./home_icon3.webp";
export { default as Loyalty } from "./home_icon4.webp";
export { default as Comma } from "./7.webp";
export { default as ReviewRate } from "./clearpath-lending.webp";

// Social Media
export { default as Facebook } from "./facebook.png";
export { default as Twitter } from "./twitter.png";
export { default as Instagram } from "./instagram.webp";

// Footer Section
export { default as FooterImg } from "./footer_img-40x40.webp";
export { default as OpinionCorpLogo } from "./opinion-corp-logo.webp";
export { default as ReviewRating } from "./review.webp";

// Client Porting
export { default as SecBottom } from "./sec_bottom.webp";
export { default as ClientPort } from "./clientportimg.webp";

// Blue
export { default as SectionTop } from "./section_top.webp";
export { default as SectionTopBlue } from "./section_top1.webp";

// Services
export { default as ExpertAdvice } from "./expert-advice.webp";
export { default as DiverseLoanOptions } from "./diverse-loan-options.webp";
export { default as ExceptionalService } from "./exceptional-service.webp";
export { default as ContactBanner } from "./contact_banner.webp";

// Buy Home
export { default as BuyHome } from "./buy.webp";
export { default as RefinanceYourHome } from "./buyhome.webp";
export { default as SectionBottom } from "./section_bottom.webp";

// Banner Shape
export { default as Banner } from "./banner1.webp";
export { default as BannerBottomShape } from "./banner_bottom_shape.webp";
export { default as BannerBottomShapeLarge } from "./banner_bottom_shape-700x140.webp";

// Home Breadcrumbs Section
export { default as People } from "./peoples.webp";

//  Quotation Marks
export { default as QuotationMarks } from "./quotation-marks.webp";

//  Home License
export { default as MapChart } from "./mapchart_Blue.webp";

// About Us Page
export { default as TopShape } from "./top_shape.webp";

// Careers Page
export { default as Careers2 } from "./career_2.webp";
export { default as Careers3 } from "./career_3.webp";
export { default as SixToOne } from "./6-1.webp";
export { default as SevenToOne } from "./7-1.webp";
export { default as JoinIcon } from "./join-icon.webp";
export { default as OurPpl } from "./our-people.webp";
export { default as WinningTeam } from "./winning-team.webp";

// Loan Types
export { default as LoanTypeBanner } from "./loan-type_bannerimg.webp";
export { default as Percentage } from "./percent.webp";
export { default as LoanOne } from "./loan-1.webp";
export { default as LoanTwo } from "./loan-2.webp";
export { default as LoanThree } from "./loan-3.webp";
export { default as LoanFour } from "./loan-4.webp";
export { default as MapChartWhite } from "./MapChart_White.webp";

// Apply Now
export { default as CPLBanner } from "./9-1.webp";

// Purchase
export { default as PurchaseHome } from "./19.webp";
export { default as StartPlanningImg } from "./25.webp";
export { default as GetPrequalifiedImg } from "./26.webp";
export { default as FindRightHomeImg } from "./27.webp";
export { default as ApplyHomeLoanImg } from "./refinancehome.webp";
export { default as ClosingNewHomeImg } from "./5.webp";
export { default as LetsTalkCredit } from "./30.webp";
export { default as BestPrice } from "./bestprice.webp";

// Refinance
export { default as RefinanceHome } from "./refinancehome-1.webp";
export { default as HomeLoan } from "./ref_img1.webp";
export { default as RefinanceBanner } from "./2.webp";
export { default as RefinanceRowOne } from "./Asset-27.webp";
export { default as RefinanceRowTwo } from "./Asset-28.webp";
export { default as FixedToAdjustable } from "./ref_icon1.webp";
export { default as RefinanceToCash } from "./ref_icon2.webp";
export { default as LowerURInterestRate } from "./ref_icon3.webp";
export { default as ShortenTermLoan } from "./ref_icon4.webp";
export { default as Reload } from "./reload.webp";
